import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'

// Configure request setup
const serviceName = 'DocumentContractsService'
const host = servicesConfig.DocumentContracts as string
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const DocumentsContractsServices = {
  getTempLibraryTemplateDocMapping: ({ locationId, templateId, snapshotStatusId }: { locationId: string; templateId: string, snapshotStatusId: string }) =>
    request().get(`/templates/get-template-document-mapping-id/${locationId}/${templateId}/${snapshotStatusId}`).then(responseBody)
}

export default DocumentsContractsServices
